import { render, staticRenderFns } from "./media_holding_file_upload.vue?vue&type=template&id=1d81c5b3&scoped=true"
import script from "./media_holding_file_upload.vue?vue&type=script&lang=js"
export * from "./media_holding_file_upload.vue?vue&type=script&lang=js"
import style0 from "./media_holding_file_upload.vue?vue&type=style&index=0&id=1d81c5b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d81c5b3",
  null
  
)

export default component.exports